import {Button, Grid} from "@mui/material";
import React, {useCallback} from "react";
import {SetState} from "../../util/FormHandlers";


export function ClearFilterButton<Filter extends {}>({emptyFilter, setFilter}: {
    emptyFilter: Filter,
    setFilter: SetState<Filter>,
}) {
    const handleClearFilters = useCallback(
        () => setFilter(emptyFilter),
        [setFilter, emptyFilter]
    )

    return (
        <Grid offset="auto">
            <Button
                variant="outlined"
                onClick={handleClearFilters}
            >
                Clear Filters
            </Button>
        </Grid>
    );
}